<template>
  <div class="form">
    <div class="field" :class="{'error': errors.phone && errors.phone.length}">
      <label class="error-label" v-if="errors.phone && errors.phone.length && !+-phone">{{ errors.phone[0] }}</label>
      <input-phone
        v-model="phone"
        :value="phone"
        :mask="phoneMask()"
        :text="$t('phone')"
        :disabled="code_sent" 
        @clear-errors="clearErrors('phone')"
      />
      <label v-if="errors.phone && errors.phone.length && phone">{{ errors.phone[0] }}</label>
      <label v-else-if="errors.phone && errors.phone.length && !phone">{{ $t('phone') }}</label>
      <label v-else>{{ $t('phone') }}</label>
    </div>

    <template v-if="code_sent">
      <field-text 
        v-model="code"
        :value="code"
        :text="$t('code_field')"
        :show-icon="true"
        :errors="errors.code"
        @clear-errors="clearErrors('code')"
      />
      
      <div class="code-ttl">{{ $t('code_ttl') }}: {{ this.time }} {{ $t('sec') }}</div>

      <button
        v-if="code_sent"
        class="button-next regular-font"
        @click="submitLogin()"
      >{{ $t('login_button') }}</button>
    </template>
    <button
      v-else
      class="button-next regular-font"
      @click="codeSend()"
    >{{ $t('next') }}</button>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import FieldText from '@/components/controls/field-text';
import InputPhone from '@/components/controls/input-phone';

export default {
  components: {
    FieldText,
    InputPhone,
  },
  props: ['dbConfig'],
  middleware: 'auth',
  auth: 'guest',
  data() {
    return {
      phone: null,
      code: null,
      code_sent: false,
      timer_id: null,
      time: 0,
      errors: {},
    }
  },
  methods: {
    phoneMask() {
      return '+7 (___) ___-__-__';
    },
    clearErrors(field) {
      this.errors[field] = [];
    },
    codeSend(){
      this.$axios.$post('/send-code/', {
        phone: this.phone
      }).then((response) => {
        this.code_sent = true;
        const timeout = this.dbConfig.phone_code_ttl || 60 * 3; // seconds
        const start = Date.now();
        this.timer_id = setInterval(() => {
          this.time = parseInt(timeout - (Date.now() - start) / 1000) ;
          if(this.time <= 0){
            this.code_sent = false;
            this.time = 0;
            clearInterval(this.timer_id);
            this.timer_id = null;
          }
        }, 500);
      }).catch((e) => {
        this.errors = e.response.data;
      });
    },
    submitLogin() {
      this.$auth.loginWith('local', {
        data: {
          phone: this.phone,
          password: this.code,
          email: 'test@test.com'
        },
      }).then((response) => {
        this.$store.dispatch('setCartExists');
        this.$store.dispatch('setPriceRequestExists');
      }).catch((e) => {
        try {
          this.errors = e.response.data;
          if (this.errors.non_field_errors) {
            this.$notify({
              duration: 5000,
              text: this.errors.non_field_errors.join(' '),
            });
          }
        } catch(e) {
          this.$notify({
            duration: 5000,
            text: this.$t('unknown_error'),
          });
        }
      });
    },
  },
}
</script>

<style scoped>
.button-next{
  text-transform: none;
}
.code-ttl{
  margin-block: 10px;
}
</style>

<i18n lang="yaml">
ru:
  password_field: 'Пароль'
  login_button: 'Войти'
  code_field: 'Код'
  code_ttl: 'Время до повторной отправки'
  next: 'Далее'
  sec: 'сек.'
en:
  password_field: 'Password'
  login_button: 'Login'
  code_field: 'Code'
  code_ttl: 'Time to repeat sending'
  next: 'Next'
  sec: 'sec.'
</i18n>
